// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wQl7","importantInfo":"styles_importantInfo__ln-WS"};